import { ACTION_TYPES } from '../constants';

export default slug => ({
  type: ACTION_TYPES.FETCH_REQUEST,
  payload: {
    slug
  }
});
